"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Popover_component_exports = {};
__export(Popover_component_exports, {
  Popover: () => Popover,
  default: () => Popover_component_default
});
module.exports = __toCommonJS(Popover_component_exports);
var import_react = __toESM(require("react"));
var import_react_popper = require("react-popper");
var import_useOnClickOutside = require("../../../utils/useOnClickOutside/useOnClickOutside.hook");
var import_useComponentId = require("../../../utils/useComponentId/useComponentId.hook");
var import_useOnKeydown = require("../../../utils/useOnKeydown/useOnKeydown.hook");
var import_Helpers = require("../../../utils/Helpers");
var import_Popover = require("./Popover.styled");
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
var _excluded = ["hasArrow", "isOpen", "offset", "placement", "referenceElem", "role", "withRole", "customPosition", "withAriaControls", "padding", "variant", "tabTrapFocus"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var Popover = function Popover2(_ref) {
  var _ref$hasArrow = _ref.hasArrow, hasArrow = _ref$hasArrow === void 0 ? true : _ref$hasArrow, _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? [0, 10] : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "right" : _ref$placement, referenceElem = _ref.referenceElem, _ref$role = _ref.role, role = _ref$role === void 0 ? "dialog" : _ref$role, _ref$withRole = _ref.withRole, withRole = _ref$withRole === void 0 ? true : _ref$withRole, _ref$customPosition = _ref.customPosition, customPosition = _ref$customPosition === void 0 ? {} : _ref$customPosition, _ref$withAriaControls = _ref.withAriaControls, withAriaControls = _ref$withAriaControls === void 0 ? true : _ref$withAriaControls, _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? "16px" : _ref$padding, _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? "light" : _ref$variant, _ref$tabTrapFocus = _ref.tabTrapFocus, tabTrapFocus = _ref$tabTrapFocus === void 0 ? true : _ref$tabTrapFocus, props = _objectWithoutProperties(_ref, _excluded);
  var componentId = (0, import_useComponentId.useComponentId)("popover");
  var popperRef = (0, import_react.useRef)(null);
  var _useState = (0, import_react.useState)(null), _useState2 = _slicedToArray(_useState, 2), arrowRef = _useState2[0], setArrowRef = _useState2[1];
  var _usePopper = (0, import_react_popper.usePopper)(referenceElem.current, popperRef.current, {
    placement,
    modifiers: [{
      name: "arrow",
      options: {
        element: arrowRef
      }
    }, {
      name: "offset",
      options: {
        offset
      }
    }]
  }), styles = _usePopper.styles, attributes = _usePopper.attributes, update = _usePopper.update;
  var closPopupFocusReferenceEle = function closPopupFocusReferenceEle2() {
    referenceElem.current.click();
    referenceElem.current.focus();
  };
  (0, import_useOnKeydown.useOnKeydown)(popperRef, function(keyList, e) {
    var Tab = keyList.Tab, Shift = keyList.Shift, Escape = keyList.Escape;
    if (Tab) {
      var focusableEls = (0, import_Helpers.getFocusableEls)(popperRef.current);
      if (Shift) {
        if (document.activeElement === focusableEls[0]) {
          e.preventDefault();
          if (tabTrapFocus) {
            focusableEls[focusableEls.length - 1].focus();
          } else {
            closPopupFocusReferenceEle();
          }
        }
      } else if (document.activeElement === focusableEls[focusableEls.length - 1]) {
        e.preventDefault();
        if (tabTrapFocus) {
          focusableEls[0].focus();
        } else {
          closPopupFocusReferenceEle();
        }
      }
    }
    if (Escape) {
      var elementsWithTooltipOpen = popperRef.current.querySelectorAll('[aria-describedby|="tippy"]');
      if (elementsWithTooltipOpen.length === 0) {
        closPopupFocusReferenceEle();
      }
    }
  });
  (0, import_useOnClickOutside.useOnClickOutside)(popperRef, function(e) {
    if (isOpen && e.target !== referenceElem.current && !referenceElem.current.contains(e.target)) {
      referenceElem.current.click();
    }
  });
  (0, import_react.useEffect)(function() {
    if (!referenceElem.current) {
      return;
    }
    referenceElem.current.setAttribute("aria-expanded", isOpen);
    if (withAriaControls) {
      referenceElem.current.setAttribute("aria-controls", componentId);
    }
    if (isOpen) {
      if (update) {
        update();
      }
      if (role === "tooltip") {
        referenceElem.current.setAttribute("aria-describedby", componentId);
      } else {
        popperRef.current.setAttribute("tabindex", -1);
        var focusableEls = (0, import_Helpers.getFocusableEls)(popperRef.current);
        if (focusableEls.length) {
          setTimeout(function() {
            var _focusableEls$;
            (_focusableEls$ = focusableEls[0]) === null || _focusableEls$ === void 0 || _focusableEls$.focus();
          }, 0);
        }
      }
    } else if (role === "tooltip") {
      referenceElem.current.removeAttribute("aria-describedby");
    }
  }, [isOpen]);
  var referenceElmEscKeyHandler = function referenceElmEscKeyHandler2() {
    referenceElem.current.click();
  };
  (0, import_react.useEffect)(function() {
    var focusableEls = (0, import_Helpers.getFocusableEls)(popperRef.current);
    if (referenceElem.current && isOpen && focusableEls.length === 0) {
      referenceElem.current.addEventListener("keydown", referenceElmEscKeyHandler);
    }
    return function() {
      var _referenceElem$curren;
      referenceElem === null || referenceElem === void 0 || (_referenceElem$curren = referenceElem.current) === null || _referenceElem$curren === void 0 || _referenceElem$curren.removeEventListener("keydown", referenceElmEscKeyHandler);
    };
  }, [referenceElem.current, isOpen]);
  return /* @__PURE__ */ import_react.default.createElement(import_Popover.StyledPopover, _extends({
    id: componentId,
    ref: popperRef,
    style: _objectSpread(_objectSpread({}, styles.popper), customPosition),
    role: withRole ? role : void 0,
    isOpen,
    padding,
    variant,
    "data-testid": "popover",
    "aria-label": props.ariaLabel,
    "aria-labelledby": props.ariaLabelledby,
    "aria-describedby": props.ariaDescribedby,
    "data-dp-analytics-id": props.dataDpAnalyticsId
  }, attributes.popper, props), /* @__PURE__ */ import_react.default.createElement("div", {
    "data-popover-arrow": hasArrow,
    ref: setArrowRef,
    style: styles.arrow,
    "data-testid": "arrow-popover"
  }), props.children);
};
var Popover_component_default = Popover;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Popover
});
//# sourceMappingURL=Popover.component.js.map